import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation, useHistory } from "react-router-dom";
import { domainToASCII } from "url";
import employeeCreditCardService from "../../services/employeeCreditCardService";
import "./employeeCreditCard.css";
import NotificationModal from "../notificationModal";
import Modal from "../modal";
import { formatAmount } from '../../util/formatAmount';

// Redux
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "../../state/index";
import { bindActionCreators } from "redux";

export default function EmployeeCreditCard() {
  const [shiftCreditCards, setShiftCreditCards] = useState([]);
  const [employeeCreditCard, setEmployeeCreditCard] = useState<any>([]);
  const [shiftId, setShiftId] = useState<any>();
  const [inputPostFailed, setInputPostFailed] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showFetchFailedModal, setShowFetchFailedModal] = useState(false);
  const [isFetchFailed, setIsFetchFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [shiftDetail, setShiftDetail] = useState<any>();
  const [failResponseMessage, setFailResponseMessage] = useState<any>();
  const [languageData, setLanguageData] = useState<any>();
  const [lastAddedRowIndex, setLastAddedRowIndex] = useState<number | null>(null);

  const history = useHistory();

  // Redux
  const dispatch = useDispatch();
  const { login, logout, register } = bindActionCreators(
    actionCreators.authActions,
    dispatch
  );
  const state = useSelector((state: State) => state);
  const { isLoggedIn } = state.authReducer;
  const stateLanguage = state.languageReducer;
  const id = useQuery().get("shiftentityid");

  useEffect(() => {
    if (!isLoggedIn) {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    getEmployeeCreditCard();
  }, []);

  useEffect(() => {
    if (isFetchFailed && !failResponseMessage) {
      toggleShowFetchFailedModal();
    }
  }, [isFetchFailed]);

  useEffect(() => {
    if (inputPostFailed === true) {
      toggleShowWarningModal();
    }
  }, [inputPostFailed]);

  useEffect(() => {
    if (shiftId) {
      const shiftIdStr = shiftId.toString();
      const year = shiftIdStr.slice(0, 4);
      const mouth = shiftIdStr.slice(4, 6);
      const day = shiftIdStr.slice(6, 8);
      const shiftNo = shiftIdStr.slice(-2);
      console.log(year, mouth, day, shiftNo);
      setShiftDetail({
        shiftId: shiftId,
        shiftDate: day + "/" + mouth + "/" + year,
        shiftNo: shiftNo,
      });
    }
  }, [shiftId]);

  useEffect(() => {
    setLanguageData(stateLanguage);
  }, [stateLanguage]);

  useEffect(() => {
    if (lastAddedRowIndex !== null) {
      const newInput = document.querySelector(`input[data-index="${lastAddedRowIndex}"]`) as HTMLInputElement;
      if (newInput) {
        newInput.focus();
        newInput.select();
      }
      setLastAddedRowIndex(null);
    }
  }, [lastAddedRowIndex]);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const handleFetchAgain = () => {
    toggleShowFetchFailedModal();
    getEmployeeCreditCard();
  };

  const toggleShowWarningModal = () => {
    setShowWarningModal(!showWarningModal);
  };

  const toggleShowFetchFailedModal = () => {
    setShowFetchFailedModal(!showFetchFailedModal);
  };

  const getEmployeeCreditCard = async () => {
    setIsFetchFailed(false);
    setIsLoading(true);
    try {
      if (!id) return null;
      const response = await employeeCreditCardService.getEmployeeCreditCard(
        Number.parseInt(id)
      );
      setFailResponseMessage(null);
      console.log(response);
      const updatedEmployeeCreditCardDetails =
        response.data.employeesCreditCardDetails.map((employee: any) => {
          const updatedCreditCard = employee.shiftCreditCards.map(
            (creditCard: any) => {
              const updatedTransactions = creditCard.transactions.map(
                (transaction: any) => {
                  return {
                    ...transaction,
                    isSaved: true,
                    isLoading: false,
                    isPostFailed: false,
                  };
                }
              );
              creditCard.transactions = [...updatedTransactions];
              return creditCard;
            }
          );
          employee.shiftCreditCards = [...updatedCreditCard];
          return employee;
        });
      setEmployeeCreditCard(updatedEmployeeCreditCardDetails);
      setShiftCreditCards(response.data.shiftCreditCardsDetails);
      setShiftId(response.data.shiftId);
      setIsFetchFailed(false);
      setIsLoading(false);
    } catch (e: any) {
      if (e.response && e.response.status === 401) {
        if (isLoggedIn) {
          dispatch(logout());
        }
        history.push("/login");
      }
      if (
        e.response &&
        (e.response.status === 403 || e.response.status === 423)
      ) {
        setFailResponseMessage(e.response.data);
      } else {
      }
      setIsFetchFailed(true);
      setIsLoading(false);
      console.dir(e);
    }
  };

  const calculateEmployeeTransactions = (shiftCreditCardEntityId: number) => {
    let amount = 0;
    employeeCreditCard.forEach((employee: any) => {
      employee.shiftCreditCards.forEach((creditCard: any) => {
        if (creditCard.shiftCreditCardEntityId === shiftCreditCardEntityId) {
          creditCard.transactions.forEach((transaction: any) => {
            amount += transaction.amount;
          });
        }
      });
    });
    return amount;
  };

  const inputChanged = (
    element: any,
    theTransaction: any,
    shiftCreditCardEntityId: number,
    employeeName: string
  ) => {
    const value = Number.parseFloat(element.target.value);
    console.log(value);
    const currentEmployeeCreditCardTransaction = calculateEmployeeTransactions(
      shiftCreditCardEntityId
    );
    const targetCreditCard: any = shiftCreditCards.filter((creditCard: any) =>
      creditCard.shiftCreditCardEntityId === shiftCreditCardEntityId
        ? true
        : false
    )[0];
    const targetCreditCardAmount = targetCreditCard.amount;
    let calculation: number;

    const updatedEmployeeCreditCard: any = employeeCreditCard.map(
      (employee: any) => {
        if (employee.employeeName === employeeName) {
          const updatedCreditCards = employee.shiftCreditCards.map(
            (creditCard: any) => {
              if (
                creditCard.shiftCreditCardEntityId === shiftCreditCardEntityId
              ) {
                const updatedTransactions = creditCard.transactions.map(
                  (transaction: any) => {
                    if (
                      theTransaction.shiftEmployeeCreditCardEntityId !== 0 &&
                      transaction.shiftEmployeeCreditCardEntityId ===
                      theTransaction.shiftEmployeeCreditCardEntityId
                    ) {
                      calculation =
                        transaction.amount +
                        targetCreditCardAmount -
                        currentEmployeeCreditCardTransaction -
                        value;
                      const roundedCalculation =
                        Math.round(calculation * 100) / 100;
                      if (roundedCalculation < 0) {
                        alert(languageData?.data?.employeeCreditCard?.alerts?.exceedAmount);
                        return transaction;
                      }
                      transaction.amount = value;
                      transaction.isSaved = false;
                      return transaction;
                    }
                    if (
                      theTransaction.shiftEmployeeCreditCardEntityId === 0 &&
                      transaction.rowId === theTransaction.rowId
                    ) {
                      calculation =
                        transaction.amount +
                        targetCreditCardAmount -
                        currentEmployeeCreditCardTransaction -
                        value;
                      const roundedCalculation =
                        Math.round(calculation * 100) / 100;
                      if (roundedCalculation < 0) {
                        alert(languageData?.data?.employeeCreditCard?.alerts?.exceedAmount);
                        return transaction;
                      }
                      transaction.amount = value;
                      transaction.isSaved = false;
                      return transaction;
                    }
                    return transaction;
                  }
                );
                creditCard.transactions = [...updatedTransactions];
                return creditCard;
              }
              return creditCard;
            }
          );
          employee.shiftCreditCards = [...updatedCreditCards];
          return employee;
        }
        return employee;
      }
    );
    setEmployeeCreditCard([...updatedEmployeeCreditCard]);
  };

  const addRow = (
    employeeName: any,
    shiftCreditCardEntityId: any,
    rowAmount: number
  ) => {
    const updatedEmployeeCreditCard = employeeCreditCard.map(
      (employee: any) => {
        if (employee.employeeName === employeeName) {
          const updatedCreditCards = employee.shiftCreditCards.map(
            (creditCard: any) => {
              if (
                creditCard.shiftCreditCardEntityId === shiftCreditCardEntityId
              ) {
                let maxRowId = 1;
                for (let i = 0; i < creditCard.transactions.length; i++) {
                  if (
                    creditCard.transactions[i].rowId &&
                    creditCard.transactions[i].rowId > maxRowId
                  ) {
                    maxRowId = creditCard.transactions[i].rowId + 1;
                  }
                }

                for (let i = 0; i < rowAmount; i++) {
                  creditCard.transactions.push({
                    shiftEmployeeCreditCardEntityId: 0,
                    amount: 0,
                    rowId: maxRowId + i,
                    isSaved: false,
                    isLoading: false,
                    isPostFailed: false,
                  });
                }
                return creditCard;
              }
              return creditCard;
            }
          );
          employee.shiftCreditCards = [...updatedCreditCards];
          return employee;
        }
        return employee;
      }
    );
    setEmployeeCreditCard([...updatedEmployeeCreditCard]);
  };

  const saveAllFailedInputs = async () => {
    const payload: any = [];
    const updatedEmployeeCreditCard = employeeCreditCard.map(
      (employee: any) => {
        const updatedCreditCards = employee.shiftCreditCards.map(
          (creditCard: any) => {
            const updatedTransactions = creditCard.transactions.map(
              (transaction: any) => {
                if (transaction.isPostFailed === true) {
                  if (transaction.rowId && transaction.isPostFailed) {
                    payload.push({
                      employeeName: employee.employeeName,
                      shiftCreditCards: [
                        {
                          shiftCreditCardEntityId:
                            creditCard.shiftCreditCardEntityId,
                          transactions: [
                            {
                              shiftEmployeeCreditCardEntityId:
                                transaction.shiftEmployeeCreditCardEntityId,
                              amount: transaction.amount,
                              rowId: transaction.rowId,
                            },
                          ],
                        },
                      ],
                    });
                    return {
                      ...transaction,
                      isPostFailed: false,
                      isLoading: true,
                      isSaved: false,
                    };
                  }
                  if (!transaction.rowId && transaction.isPostFailed) {
                    payload.push({
                      employeeName: employee.employeeName,
                      shiftCreditCards: [
                        {
                          shiftCreditCardEntityId:
                            creditCard.shiftCreditCardEntityId,
                          transactions: [
                            {
                              shiftEmployeeCreditCardEntityId:
                                transaction.shiftEmployeeCreditCardEntityId,
                              amount: transaction.amount,
                            },
                          ],
                        },
                      ],
                    });
                    return {
                      ...transaction,
                      isPostFailed: false,
                      isLoading: true,
                      isSaved: false,
                    };
                  }
                }
                return transaction;
              }
            );
            creditCard.transactions = [...updatedTransactions];
            return creditCard;
          }
        );
        employee.shiftCreditCards = [...updatedCreditCards];
        return employee;
      }
    );
    setEmployeeCreditCard(updatedEmployeeCreditCard);

    try {
      const response: any =
        await employeeCreditCardService.saveOrUpdateEmployeeCreditCard(payload);
      setInputPostFailed(false);

      const updatedEmployeeCreditCardDetails = employeeCreditCard.map(
        (employee: any) => {
          const updatedShiftCreditCards = employee.shiftCreditCards.map(
            (creditCard: any) => {
              const updatedTransactions = creditCard.transactions.map(
                (transaction: any) => {
                  for (let i = 0; i < response.data.length; i++) {
                    const dto = response.data[i];
                    if (
                      transaction.rowId &&
                      dto.rowId &&
                      transaction.rowId === dto.rowId
                    ) {
                      return {
                        shiftEmployeeCreditCardEntityId:
                          dto.shiftEmployeeCreditCardEntityId,
                        amount: transaction.amount,
                        isLoading: false,
                        isSaved: true,
                        isPostFailed: false,
                      };
                    }
                    if (
                      transaction.shiftEmployeeCreditCardEntityId ===
                      dto.shiftEmployeeCreditCardEntityId
                    ) {
                      return {
                        ...transaction,
                        isLoading: false,
                        isSaved: true,
                        isPostFailed: false,
                      };
                    }
                  }
                  return { ...transaction, isLoading: false };
                }
              );
              creditCard.transactions = [...updatedTransactions];
              return creditCard;
            }
          );
          employee.shiftCreditCards = [...updatedShiftCreditCards];
          return employee;
        }
      );
      setEmployeeCreditCard(updatedEmployeeCreditCardDetails);
    } catch (error: any) {
      setInputPostFailed(true);
      const updatedEmployeeCreditCardDetails = employeeCreditCard.map(
        (employee: any) => {
          const updatedShiftCreditCards = employee.shiftCreditCards.map(
            (creditCard: any) => {
              const updatedTransactions = creditCard.transactions.map(
                (transaction: any) => {
                  for (let i = 0; i < payload.length; i++) {
                    const theTransaction =
                      payload[i].shiftCreditCards[0].transactions[0];
                    if (
                      transaction.rowId &&
                      theTransaction.rowId &&
                      transaction.rowId === theTransaction.rowId
                    ) {
                      return {
                        ...transaction,
                        isPostFailed: true,
                        isLoading: false,
                        isSaved: false,
                      };
                    }
                    if (
                      !transaction.rowId &&
                      transaction.shiftEmployeeCreditCardEntityId ===
                      theTransaction.shiftEmployeeCreditCardEntityId
                    ) {
                      return {
                        ...transaction,
                        isPostFailed: true,
                        isLoading: false,
                        isSaved: false,
                      };
                    }
                  }
                  return transaction;
                }
              );
              creditCard.transactions = [...updatedTransactions];
              return creditCard;
            }
          );
          employee.shiftCreditCards = [...updatedShiftCreditCards];
          return employee;
        }
      );
      setEmployeeCreditCard(updatedEmployeeCreditCardDetails);
      console.dir(error);
    }
  };

  const saveSingleInput = async (
    theTransaction: any,
    shiftCreditCardEntityId: any,
    employeeName: any
  ) => {
    try {
      if (Number.isNaN(theTransaction.amount)) {
        console.log("did not post");
        return;
      }
      const updatedEmployeeCreditCardDetailsBeforePost = employeeCreditCard.map(
        (employee: any) => {
          if (employee.employeeName === employeeName) {
            const updatedCreditCards = employee.shiftCreditCards.map(
              (creditCard: any) => {
                if (
                  creditCard.shiftCreditCardEntityId === shiftCreditCardEntityId
                ) {
                  const updatedTransactions = creditCard.transactions.map(
                    (transaction: any) => {
                      if (
                        transaction.rowId &&
                        theTransaction.rowId &&
                        transaction.rowId === theTransaction.rowId
                      ) {
                        return { ...transaction, isLoading: true };
                      }
                      if (
                        !transaction.rowId &&
                        transaction.shiftEmployeeCreditCardEntityId ===
                        theTransaction.shiftEmployeeCreditCardEntityId
                      ) {
                        return { ...transaction, isLoading: true };
                      }
                      return transaction;
                    }
                  );
                  creditCard.transactions = [...updatedTransactions];
                  return creditCard;
                }
                return creditCard;
              }
            );
            employee.shiftCreditCards = [...updatedCreditCards];
            return employee;
          }
          return employee;
        }
      );
      setEmployeeCreditCard(updatedEmployeeCreditCardDetailsBeforePost);

      let payload;
      if (theTransaction.rowId != null) {
        payload = [
          {
            employeeName: employeeName,
            shiftCreditCards: [
              {
                shiftCreditCardEntityId: shiftCreditCardEntityId,
                transactions: [
                  {
                    shiftEmployeeCreditCardEntityId:
                      theTransaction.shiftEmployeeCreditCardEntityId,
                    amount: theTransaction.amount,
                    rowId: theTransaction.rowId,
                  },
                ],
              },
            ],
          },
        ];
      }
      if (theTransaction.rowId == null) {
        payload = [
          {
            employeeName: employeeName,
            shiftCreditCards: [
              {
                shiftCreditCardEntityId: shiftCreditCardEntityId,
                transactions: [
                  {
                    shiftEmployeeCreditCardEntityId:
                      theTransaction.shiftEmployeeCreditCardEntityId,
                    amount: theTransaction.amount,
                  },
                ],
              },
            ],
          },
        ];
      }

      const response: any =
        await employeeCreditCardService.saveOrUpdateEmployeeCreditCard(payload);
      setInputPostFailed(false);

      const updatedEmployeeCreditCardDetails = employeeCreditCard.map(
        (employee: any) => {
          const updatedShiftCreditCards = employee.shiftCreditCards.map(
            (creditCard: any) => {
              const updatedTransactions = creditCard.transactions.map(
                (transaction: any) => {
                  for (let i = 0; i < response.data.length; i++) {
                    const dto = response.data[i];
                    if (
                      transaction.rowId &&
                      dto.rowId &&
                      transaction.rowId === dto.rowId &&
                      creditCard.shiftCreditCardEntityId ===
                      shiftCreditCardEntityId
                    ) {
                      return {
                        shiftEmployeeCreditCardEntityId:
                          dto.shiftEmployeeCreditCardEntityId,
                        amount: transaction.amount,
                        isLoading: false,
                        isSaved: true,
                        isPostFailed: false,
                      };
                    }
                    if (
                      transaction.shiftEmployeeCreditCardEntityId ===
                      dto.shiftEmployeeCreditCardEntityId &&
                      creditCard.shiftCreditCardEntityId ===
                      shiftCreditCardEntityId
                    ) {
                      return {
                        ...transaction,
                        isLoading: false,
                        isSaved: true,
                        isPostFailed: false,
                      };
                    }
                  }
                  return { ...transaction, isLoading: false };
                }
              );
              creditCard.transactions = [...updatedTransactions];
              return creditCard;
            }
          );
          employee.shiftCreditCards = [...updatedShiftCreditCards];
          return employee;
        }
      );
      setEmployeeCreditCard(updatedEmployeeCreditCardDetails);
    } catch (error: any) {
      setInputPostFailed(true);
      const updatedEmployeeCreditCardDetails = employeeCreditCard.map(
        (employee: any) => {
          const updatedShiftCreditCards = employee.shiftCreditCards.map(
            (creditCard: any) => {
              const updatedTransactions = creditCard.transactions.map(
                (transaction: any) => {
                  if (
                    transaction.rowId &&
                    theTransaction.rowId &&
                    transaction.rowId === theTransaction.rowId
                  ) {
                    return {
                      ...transaction,
                      isPostFailed: true,
                      isLoading: false,
                      isSaved: false,
                    };
                  }
                  if (
                    !transaction.rowId &&
                    transaction.shiftEmployeeCreditCardEntityId ===
                    theTransaction.shiftEmployeeCreditCardEntityId
                  ) {
                    return {
                      ...transaction,
                      isPostFailed: true,
                      isLoading: false,
                      isSaved: false,
                    };
                  }
                  return transaction;
                }
              );
              creditCard.transactions = [...updatedTransactions];
              return creditCard;
            }
          );
          employee.shiftCreditCards = [...updatedShiftCreditCards];
          return employee;
        }
      );
      setEmployeeCreditCard(updatedEmployeeCreditCardDetails);
      console.dir(error);
    }
  };

  const calculateTotalCreditCardAmount = () => {
    let amount = 0;
    shiftCreditCards.forEach((creditCard: any) => {
      amount += creditCard.amount;
    });
    return amount;
  };

  const calculateTotalEmployeeTransactions = () => {
    let amount = 0;
    employeeCreditCard.forEach((employee: any) => {
      employee.shiftCreditCards.forEach((creditCard: any) => {
        creditCard.transactions.forEach((transaction: any) => {
          amount += transaction.amount;
        });
      });
    });
    return amount;
  };

  const calculateEmployeeDeficit = (employee: any) => {
    let deficit = employee.employeeDeficit;
    employee.shiftCreditCards.forEach((creditCard: any) => {
      creditCard.transactions.forEach((transaction: any) => {
        deficit += transaction.amount;
      });
    });
    return deficit;
  };

  const totalCreditCardAmount = calculateTotalCreditCardAmount();
  const totalEmployeeTransactionAmount = calculateTotalEmployeeTransactions();

  const spinner = (
    <div key={"spinner"}>
      <div className="d-flex justify-content-center ">
        <div className="spinner-border spinner" role="status"></div>
      </div>
      <div
        style={{ marginTop: "1.5%" }}
        className="d-flex justify-content-center"
      >
        <p style={{ fontStyle: "oblique" }}>{languageData?.data?.employeeCreditCard?.loading}</p>
      </div>
    </div>
  );

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, currentIndex: number, transactions: any[], creditCard: any, employee: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();

      if (currentIndex >= transactions.length - 1) {
        const currentTransaction = transactions[currentIndex];
        if (currentTransaction.amount > 0) {
          addRow(
            employee.employeeName,
            creditCard.shiftCreditCardEntityId,
            10
          );
        }
      }
      setLastAddedRowIndex(currentIndex + 1);
    }
  };

  return (
    <div>
      {failResponseMessage && (
        <div>
          <h1>{failResponseMessage.message}</h1>
          {failResponseMessage.details.map((detail: any) => {
            return <h4>{detail}</h4>;
          })}
        </div>
      )}
      {isFetchFailed ? (
        <div
          key={"postfailed"}
          className={"justify-content-center"}
          style={{ alignContent: "center", alignItems: "center" }}
        >
          <h1>{languageData?.data?.employeeCreditCard?.fetchFailed}</h1>
          <div style={{ display: "flex" }}>
            <Button onClick={getEmployeeCreditCard} style={{ margin: "auto" }}>
              {languageData?.data?.employeeCreditCard?.buttons.fetchAgain}
              {isLoading && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
            </Button>
          </div>
        </div>
      ) : (
        <div key={"outer"}>
          {isLoading ? (
            spinner
          ) : (
            <div key={"inner"}>
              <div key={"inner-1"} className={"component-custom-border"}>
                <table className={"table-custom-border"}>
                  <thead>
                    <tr>
                      <th className={"custom-th-td"}>{languageData?.data?.employeeCreditCard?.table.shiftId}</th>
                      <th className={"custom-th-td"}>{languageData?.data?.employeeCreditCard?.table.shiftDate}</th>
                      <th className={"custom-th-td"}>{languageData?.data?.employeeCreditCard?.table.shiftNo}</th>
                    </tr>
                  </thead>
                  <tbody key={"body-1"}>
                    <tr>
                      <td className={"custom-th-td"}>{shiftId}</td>
                      <td className={"custom-th-td"}>
                        {shiftDetail.shiftDate}
                      </td>
                      <td className={"custom-th-td"}>{shiftDetail.shiftNo}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div key={"inner-2"} className={"component-custom-border"}>
                <table className={"table-custom-border"}>
                  <thead>
                    <tr>
                      <th className={"custom-th-td"}>{languageData?.data?.employeeCreditCard?.table.totalCreditCardAmount}</th>
                      <th className={"custom-th-td"}>{languageData?.data?.employeeCreditCard?.table.totalEmployeeTransactions}</th>
                      <th className={"custom-th-td"}>{languageData?.data?.employeeCreditCard?.table.totalDifference}</th>
                    </tr>
                  </thead>
                  <tbody key={"body-2"}>
                    <tr>
                      <td className={"custom-th-td"}>
                        {formatAmount(totalCreditCardAmount, languageData?.data?.general?.locale)}&#8378;
                      </td>
                      <td className={"custom-th-td"}>
                        {formatAmount(totalEmployeeTransactionAmount, languageData?.data?.general?.locale)}&#8378;
                      </td>
                      <td className={"custom-th-td"}>
                        {formatAmount(totalCreditCardAmount - totalEmployeeTransactionAmount, languageData?.data?.general?.locale)}&#8378;
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className={"button-group justify-content-center"}>
                  <Button
                    onClick={() =>
                      history.push("/shiftreview?shiftsentityid=" + id)
                    }
                  >
                    {languageData?.data?.employeeCreditCard?.buttons.goToReview}
                  </Button>
                </div>
              </div>

              <div key={"inner-3"} className={"component-custom-border"}>
                <h3>{languageData?.data?.employeeCreditCard?.table.bankName}</h3>
                <table className={"table-custom-border"}>
                  <thead>
                    <tr>
                      <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.employeeCreditCard?.table.bankName}</th>
                      <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.employeeCreditCard?.table.batchNo}</th>
                      <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.employeeCreditCard?.table.amount}</th>
                      <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.employeeCreditCard?.table.employeeTransactions}</th>
                      <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.employeeCreditCard?.table.difference}</th>
                    </tr>
                  </thead>
                  <tbody key={"body-3"}>
                    {shiftCreditCards.map((creditCard: any, index: number) => {
                      const employeeTransactionSum =
                        calculateEmployeeTransactions(
                          creditCard.shiftCreditCardEntityId
                        );
                      return (
                        <tr key={index}>
                          <td className={"custom-th-td"}>
                            {creditCard.bankName}
                          </td>
                          <td className={"custom-th-td"}>
                            {creditCard.batchNo}
                          </td>
                          <td className={"custom-th-td"}>
                            {formatAmount(creditCard.amount, languageData?.data?.general?.locale)}&#8378;
                          </td>
                          <td className={"custom-th-td"}>
                            {" "}
                            {employeeTransactionSum.toFixed(2)}&#8378;
                          </td>
                          <td className={"custom-th-td"}>
                            {formatAmount(creditCard.amount - employeeTransactionSum, languageData?.data?.general?.locale)}&#8378;
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}

      {inputPostFailed ? (
        <div
          key={"button"}
          style={{ margin: "auto", display: "block", textAlign: "center" }}
        >
          <hr />
          <h4 style={{ color: "red" }}>{languageData?.data?.employeeCreditCard?.warning.title}</h4>
          <h5>{languageData?.data?.employeeCreditCard?.warning.message}</h5>
          <Button onClick={saveAllFailedInputs}>
            {languageData?.data?.employeeCreditCard?.buttons.saveAll}
          </Button>
        </div>
      ) : null}
      {employeeCreditCard.map((employee: any, index: number) => {
        return (
          <div key={"employee" + index}>
            <hr />
            <h3>{employee.employeeName}</h3>
            <h3>
              {languageData?.data?.employeeCreditCard?.currentDeficit}: {formatAmount(calculateEmployeeDeficit(employee), languageData?.data?.general?.locale)}
              &#8378;
            </h3>
            <div
              key={"credit-card"}
              className={"transactions-parent-div justify-content-center"}
            >
              {employee.shiftCreditCards.map(
                (creditCard: any, index: number) => {
                  let transactionSum = 0;

                  return (
                    <div
                      key={"transaction" + index}
                      className={"transaction-table-div"}
                    >
                      <table className={"transaction-table"}>
                        <thead>
                          <tr>
                            <th>{creditCard.bankName}</th>
                          </tr>
                          <tr>
                            <td>{creditCard.batchNo}</td>
                          </tr>
                        </thead>

                        <tbody key={"body" + index}>
                          {creditCard.transactions.map(
                            (transaction: any, index: number) => {
                              transactionSum += transaction.amount;
                              let inputClass = "";
                              if (transaction.isSaved) {
                                inputClass = "inputSaved";
                              }
                              if (
                                !transaction.isSaved &&
                                !transaction.isPostFailed &&
                                !transaction.isLoading
                              ) {
                                inputClass = "inputNotSaved";
                              }
                              if (transaction.isLoading) {
                                inputClass = "inputLoading";
                              }
                              if (transaction.isPostFailed) {
                                inputClass = "inputPostFailed";
                              }
                              return (
                                <tr
                                  key={
                                    "tr" +
                                    transaction.shiftEmployeeCreditCardEntityId +
                                    index
                                  }
                                >
                                  <td
                                    key={
                                      "td" +
                                      transaction.shiftEmployeeCreditCardEntityId +
                                      index
                                    }
                                  >
                                    <input
                                      className={inputClass}
                                      key={index + "input"}
                                      data-index={index}
                                      type="number"
                                      disabled={transaction.isLoading}
                                      step=".01"
                                      value={transaction.amount}
                                      onChange={(element: any) =>
                                        inputChanged(
                                          element,
                                          transaction,
                                          creditCard.shiftCreditCardEntityId,
                                          employee.employeeName
                                        )
                                      }
                                      onKeyDown={(event) =>
                                        handleKeyDown(
                                          event,
                                          index,
                                          creditCard.transactions,
                                          creditCard,
                                          employee
                                        )
                                      }
                                      onBlur={() =>
                                        saveSingleInput(
                                          transaction,
                                          creditCard.shiftCreditCardEntityId,
                                          employee.employeeName
                                        )
                                      }
                                    />
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                      <p>
                        {languageData?.data?.employeeCreditCard?.totalTransaction}: {formatAmount(transactionSum, languageData?.data?.general?.locale)}&#8378;
                      </p>
                      <Button
                        style={{ marginBottom: "5%" }}
                        onClick={() =>
                          addRow(
                            employee.employeeName,
                            creditCard.shiftCreditCardEntityId,
                            10
                          )
                        }
                      >
                        {languageData?.data?.employeeCreditCard?.addRow}
                      </Button>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        );
      })}
      <NotificationModal
        show={showWarningModal}
        handleClose={toggleShowWarningModal}
        onTrue={toggleShowWarningModal}
        buttonText={"Okay"}
        // totalCash={cashSum}
        question={
          "Connection is lost, please check your connection and click 'Save All' button."
        }
      />
      <Modal
        show={showFetchFailedModal}
        handleClose={toggleShowFetchFailedModal}
        onTrue={handleFetchAgain}
        buttonText={"Retry"}
        question={"Fetch failed, would you like to try again?"}
      />
    </div>
  );
}
